import React, { useState, useEffect } from "react";
import $ from "jquery";
import _ from "underscore";
import propTypes from "prop-types";
import { MultiCheckBox } from "./components/Selector";

DetailCriteria.propTypes = {
    onOff: propTypes.bool,
    criteria: propTypes.object,
    setCriteria: propTypes.func,
};

export default function DetailCriteria(props) {
    const [displayStyle, setDisplayStyle] = useState("hidden");

    const innings = [
        { value: "1", dataLang: "inning1", label: "1이닝" },
        { value: "2", dataLang: "inning2", label: "2이닝" },
        { value: "3", dataLang: "inning3", label: "3이닝" },
        { value: "4", dataLang: "inning4", label: "4이닝" },
        { value: "5", dataLang: "inning5", label: "5이닝" },
        { value: "6", dataLang: "inning6", label: "6이닝" },
        { value: "7", dataLang: "inning7", label: "7이닝" },
        { value: "8", dataLang: "inning8", label: "8이닝" },
        { value: "9", dataLang: "inning9", label: "9이닝" },
        { value: "10", dataLang: "inning10", label: "10이닝" },
        { value: "11", dataLang: "inning11", label: "11이닝" },
        { value: "12", dataLang: "inning12", label: "12이닝" },
    ];

    const ballCodes = [
        { value: "6116", dataLang: "fastball", label: "직구" },
        { value: "6101", dataLang: "twoSeamer", label: "투심" },
        { value: "6117", dataLang: "cutter", label: "커터" },
        { value: "6111", dataLang: "slider", label: "슬라이더" },
        { value: "6108", dataLang: "curve", label: "커브" },
        { value: "6103", dataLang: "changeUp", label: "체인지업" },
        { value: "6107", dataLang: "fork", label: "포크" },
        { value: "6199", dataLang: "other", label: "기타" },
    ];
    const runnerStatus = [
        { value: "0", dataLang: "noRunner", label: "주자없음" },
        { value: "1", dataLang: "runner1st", label: "1루" },
        { value: "2", dataLang: "runner2nd", label: "2루" },
        { value: "4", dataLang: "runner3rd", label: "3루" },
        { value: "3", dataLang: "runner1st2nd", label: "1-2루" },
        { value: "5", dataLang: "runner1st3rd", label: "1-3루" },
        { value: "6", dataLang: "runner2nd3rd", label: "2-3루" },
        { value: "7", dataLang: "baseLoaded", label: "만루" },
    ];
    const ballCounts = [
        { value: "0-0", label: "[0-0]" },
        { value: "0-1", label: "[0-1]" },
        { value: "0-2", label: "[0-2]" },
        { value: "1-0", label: "[1-0]" },
        { value: "1-1", label: "[1-1]" },
        { value: "1-2", label: "[1-2]" },
        { value: "2-0", label: "[2-0]" },
        { value: "2-1", label: "[2-1]" },
        { value: "2-2", label: "[2-2]" },
        { value: "3-0", label: "[3-0]" },
        { value: "3-1", label: "[3-1]" },
        { value: "3-2", label: "[3-2]" },
    ];
    const hitTypes = [
        { value: "6301", dataLang: "standing", label: "스탠딩" },
        { value: "6302", dataLang: "hitting", label: "타격" },
        { value: "6303", dataLang: "strikeSwinging", label: "헛스윙" },
        { value: "6306", dataLang: "buntPlay", label: "번트" },
    ];
    const hitResults = [
        { value: "6604", dataLang: "single", label: "단타" },
        { value: "6607", dataLang: "double", label: "2루타" },
        { value: "6610", dataLang: "triple", label: "3루타" },
        { value: "6613", dataLang: "homeRun", label: "홈런" },
        { value: "6629", dataLang: "itpHomeRun", label: "그라운드홈런" },
        { value: "6638", dataLang: "groundBall", label: "땅볼" },
        { value: "6615", dataLang: "reachedOnErr", label: "실책출루" },
        { value: "6622", dataLang: "fielderChoice", label: "야선출루" },
        { value: "6608", dataLang: "doublePlay", label: "병살타" },
        { value: "6645", dataLang: "triplePlay", label: "삼중살" },
        { value: "6605", dataLang: "groundOut", label: "땅볼아웃" },
        { value: "6602", dataLang: "flyOut", label: "플라이아웃" },
        { value: "6612", dataLang: "lineOut", label: "직선타아웃" },
        { value: "6619", dataLang: "infieldFly", label: "인필드플라이아웃" },
        { value: "6601", dataLang: "foul", label: "파울" },
        { value: "6630", dataLang: "foulFlyOut", label: "파울플라이아웃" },
        { value: "6614", dataLang: "sacFly", label: "희비아웃" },
        { value: "6616", dataLang: "sacBunt", label: "희번아웃" },
        { value: "6633", dataLang: "hittingObstruction", label: "타격방해" },
        { value: "6636", dataLang: "fieldingInter", label: "수비방해" },
        { value: "6656", dataLang: "runningObstruction", label: "주루방해" },
        { value: "6603", dataLang: "strikeOut", label: "삼진아웃" },
        { value: "6606", dataLang: "baseOnBalls", label: "볼넷" },
        { value: "6609", dataLang: "hitByPitch", label: "사구(HP)" },
        { value: "6624", dataLang: "notOutSafe", label: "낫아웃(세이프)" },
        { value: "6625", dataLang: "balk", label: "보크" },
        { value: "6626", dataLang: "wildPitch", label: "폭투" },
        { value: "6628", dataLang: "intentionalBB", label: "고의4구" },
        { value: "6632", dataLang: "passedBalls", label: "포일" },
        { value: "6635", dataLang: "buntFailedOut", label: "3번트아웃" },
    ];

	const battedBallTypeCodes = [
		{ value: "6701", dataLang: "groundBall", label: "땅볼" },
		{ value: "6702", dataLang: "lineDrive", label: "라인드라이브" },
		{ value: "6703", dataLang: "flyBall", label: "뜬공" },
	]

    const checkbases = [
        { value: "1", dataLang: "pick1st", label: "1루견제" },
        { value: "2", dataLang: "pick2nd", label: "2루견제" },
        { value: "3", dataLang: "pick3rd", label: "3루견제" },
        { value: "14", dataLang: "pickHome", label: "홈견제" },
        { value: "21", dataLang: "catcherPick1st", label: "포수1루견제" },
        { value: "22", dataLang: "catcherPick2nd", label: "포수2루견제" },
        { value: "23", dataLang: "catcherPick3rd", label: "포수3루견제" },
    ];

    const battedBallRanks = [
        { value: "N", dataLang: "rankNone", label: "없음" },
        { value: "A", dataLang: "rankA", label: "A" },
        { value: "B", dataLang: "rankB", label: "B" },
        { value: "C", dataLang: "rankC", label: "C" },
    ];

	const pitcherTypes = [
		{ value: "L", dataLang: "leftPitcher", label: "좌투"},
		{ value: "R", dataLang: "rightPitcher", label: "우투"},
		{ value: "S", dataLang: "sidePitcher", label: "사이드"},
	];

	const batterTypes = [
		{ value: "L", dataLang: "leftBatter", label: "좌타"},
		{ value: "R", dataLang: "rightBatter", label: "우타"},
	];

    const minBallSpeed = [
        { value: "100", dataLang: "100", label: "100" },
        { value: "105", dataLang: "105", label: "105" },
        { value: "110", dataLang: "110", label: "110" },
        { value: "115", dataLang: "115", label: "115" },
        { value: "120", dataLang: "120", label: "120" },
        { value: "125", dataLang: "125", label: "125" },
        { value: "130", dataLang: "130", label: "130" },
        { value: "135", dataLang: "135", label: "135" },
        { value: "140", dataLang: "140", label: "140" },
        { value: "145", dataLang: "145", label: "145" },
        { value: "150", dataLang: "150", label: "150" },
        { value: "155", dataLang: "155", label: "155" },
        { value: "160", dataLang: "160", label: "160" },
        { value: "165", dataLang: "165~", label: "165~" },
    ]

    const maxBallSpeed = [
        { value: "100", dataLang: "~100", label: "~100" },
        { value: "105", dataLang: "105", label: "105" },
        { value: "110", dataLang: "110", label: "110" },
        { value: "115", dataLang: "115", label: "115" },
        { value: "120", dataLang: "120", label: "120" },
        { value: "125", dataLang: "125", label: "125" },
        { value: "130", dataLang: "130", label: "130" },
        { value: "135", dataLang: "135", label: "135" },
        { value: "140", dataLang: "140", label: "140" },
        { value: "145", dataLang: "145", label: "145" },
        { value: "150", dataLang: "150", label: "150" },
        { value: "155", dataLang: "155", label: "155" },
        { value: "160", dataLang: "160", label: "160" },
        { value: "165", dataLang: "165", label: "165" },
    ]

    useEffect(() => {
        let newStyle = props.onOff ? "show" : "hidden";
        setDisplayStyle(newStyle);
    }, [props.onOff]);

    useEffect(() => {
        // criteria 바뀌면서 localStorage 값 변경 시 상세조건 색칠 여부 다시 결정
        $(".select-detail-criteria").each(function() {
            const button = $(this);
            const name = button.attr('name');
            const value = button.attr('value');

            if (props.criteria && props.criteria[name] !== undefined) {
                const criteriaValue = props.criteria[name];

                // criteria 값(배열 또는 단일 값)에 현재 버튼의 value가 포함되어 있는지 확인
                const isActive = Array.isArray(criteriaValue)
                    ? criteriaValue.includes(value)
                    : criteriaValue === value;

                if (isActive) {
                    button.addClass("active");
                } else {
                    button.removeClass("active");
                }
            }
        });
    },[props.criteria]);


    const changeHandler = (evt) => {
        let target = $(evt.currentTarget);
        let property = target.attr("name");
        let changedCriteria = { ...props.criteria };

        if (evt.target.className === "select-detail-criteria active") {
            target.removeClass("active");
            //evt.currentTarget.style.backgroundColor = "";
        } else {
            target.addClass("active");
            //evt.currentTarget.style.backgroundColor = "orange";
        }

        //새로고침하더라도 저장된 선택 값들에 대해서는 스타일이 유지되어야 한다.

        //해당 name에 들어가는 값 중에서 class가 active인 것을 모두 가져와야함 (배열의 형태로)
        var values = $("[name='" + property + "']");

        var selectedItems = _.filter(values, function (value) {
            return $(value).hasClass("active");
        });

        var detailArr = [];

        selectedItems.forEach(function (item) {
            var val = $(item).attr("value");
            detailArr.push(val);
        });

        changedCriteria[property] = detailArr;

        props.setCriteria(changedCriteria);
    };

    const ballSpeedChangeHandler = (evt) => {
        //구속 클릭 이벤트 핸들러
        let target = $(evt.currentTarget);
        let property = target.attr("name");
        let changedCriteria = { ...props.criteria };

        var values = $("[name='" + property + "']");

        var selectedItems = _.filter(values, function (value) {
            return $(value).hasClass("active");
        });

        if (evt.target.className === "select-detail-criteria active") {
            target.removeClass("active");
            changedCriteria[property] = "";
        } else {
            if(selectedItems.length > 0){
                alert("최대 1개까지 선택이 가능합니다.");
            } else {
                target.addClass("active");
                changedCriteria[property] = target.attr("value");
            }
        }

        props.setCriteria(changedCriteria);
    }

    //상세조건만 초기화 해주는 이벤트 핸들러
    const resetDetailCreteriaHandler = () => {
        props.setCriteria((prevState) => ({
            ...prevState,
            innings: [],
            checkbases: [],
            ballCodes: [],
            ballCounts: [],
            runnerStatus: [],
            hitTypes: [],
            hitResults: [],
            battedBallTypeCodes: [],
            battedBallRanks: [],
			pitcherTypes: [],
			batterTypes: [],
            minBallSpeed: "",
            maxBallSpeed: ""
        }));

        props.detailCriteria.forEach(function (item) {
            $("[name='" + item + "']").css("backgroundColor", "");
            $("[name='" + item + "']").removeClass("active");
        });
    };

    return (
        <div
            id="detailCriteriaArea"
            className={`col-12 ${displayStyle}`}
            style={{ marginBottom: "15px" }}
        >
            <div style={{ display: "flex", flexWrap: "nowrap" }}>
                <h5>
                    <small data-lang="detailedFilter">상세 조건</small>
                </h5>
                <button
                    id="detailReset"
                    className=""
                    style={{
                        borderRadius: "20px 20px 20px 20px",
                        marginLeft: "15px",
                        fontSize: "13px",
                        height: "27px",
                    }}
                    onClick={resetDetailCreteriaHandler}
                >
                    Reset
                </button>
            </div>
            <div className="row">
                <div className={props.isMobile ? "col-12" : "col-6"} style={props.isMobile ? {paddingBottom: "5px"} : {}}>
                    <MultiCheckBox
                        title={"이닝"}
                        id="innings"
                        name="innings"
                        options={innings}
                        value={props.criteria.innings}
                        setValue={changeHandler}
                        dataLang={"inning"}
                        useLang={props.useLang}
                    />
                </div>
                <div className={props.isMobile ? "col-12" : "col-6"}>
                    <MultiCheckBox
                        title={"견제"}
                        id="checkbases"
                        name="checkbases"
                        options={checkbases}
                        value={props.criteria.checkbases}
                        setValue={changeHandler}
                        dataLang={"pickOffs"}
                        useLang={props.useLang}
                    />
                </div>
            </div>
            <div className="row" style={props.isMobile ? { marginTop: "5px" } : { marginTop: "10px" }}>
                <div className={props.isMobile ? "col-12" : "col-6"} style={props.isMobile ? {paddingBottom: "5px"} : {}}>
                    <MultiCheckBox
                        title={"구종"}
                        id="ballCodes"
                        name="ballCodes"
                        options={ballCodes}
                        value={props.criteria.ballCodes}
                        setValue={changeHandler}
                        dataLang={"pitchType"}
                        useLang={props.useLang}
                    />
                </div>
                <div className={props.isMobile ? "col-12" : "col-6"}>
                    <MultiCheckBox
                        title={"카운트"}
                        id="ballCounts"
                        name="ballCounts"
                        options={ballCounts}
                        value={props.criteria.ballCounts}
                        setValue={changeHandler}
                        dataLang={"count"}
                        useLang={props.useLang}
                    />
                </div>
            </div>
            <div className="row" style={props.isMobile ? { marginTop: "5px" } : { marginTop: "10px" }}>
                <div className={props.isMobile ? "col-12" : "col-6"} style={props.isMobile ? {paddingBottom: "5px"} : {}}>
                    <MultiCheckBox
                        title={"주자"}
                        id="runnerStatus"
                        name="runnerStatus"
                        options={runnerStatus}
                        value={props.criteria.runnerStatus}
                        setValue={changeHandler}
                        dataLang={"runner"}
                        useLang={props.useLang}
                    />
                </div>
                <div className={props.isMobile ? "col-12" : "col-6"}>
                    <MultiCheckBox
                        title={"타격유형"}
                        id="hitTypes"
                        name="hitTypes"
                        options={hitTypes}
                        value={props.criteria.hitTypes}
                        setValue={changeHandler}
                        dataLang={"hitType"}
                        useLang={props.useLang}
                    />
                </div>
            </div>
			<div className="row" style={props.isMobile ? { marginTop: "5px" } : { marginTop: "10px" }}>
                <div className={props.isMobile ? "col-12" : "col-6"} style={props.isMobile ? {paddingBottom: "5px"} : {}}>
                    <MultiCheckBox
                        title={"투수유형"}
                        id="pitcherTypes"
                        name="pitcherTypes"
                        options={pitcherTypes}
                        value={props.criteria.pitcherTypes}
                        setValue={changeHandler}
                        dataLang={"pitcherTypes"}
                        useLang={props.useLang}
                    />
                </div>
                <div className={props.isMobile ? "col-12" : "col-6"}>
                    <MultiCheckBox
                        title={"타자유형"}
                        id="batterTypes"
                        name="batterTypes"
                        options={batterTypes}
                        value={props.criteria.batterTypes}
                        setValue={changeHandler}
                        dataLang={"batterTypes"}
                        useLang={props.useLang}
                    />
                </div>
            </div>
            <div className="row" style={props.isMobile ? { marginTop: "5px" } : { marginTop: "10px" }}>
                <div className={props.isMobile ? "col-12" : "col-6"} style={props.isMobile ? {paddingBottom: "5px"} : {}}>
                    <MultiCheckBox
                        title={"타구유형"}
                        id="battedBallTypeCodes"
                        name="battedBallTypeCodes"
                        options={battedBallTypeCodes}
                        value={props.criteria.battedBallTypeCodes}
                        setValue={changeHandler}
                        dataLang={"battedBallType"}
                        useLang={props.useLang}
                    />
                </div>
                <div className={props.isMobile ? "col-12" : "col-6"}>
                    <MultiCheckBox
                        title={"타구랭크"}
                        id="battedBallRanks"
                        name="battedBallRanks"
                        options={battedBallRanks}
                        value={props.criteria.battedBallRanks}
                        setValue={changeHandler}
                        dataLang={"battedBallRanks"}
                        useLang={props.useLang}
                    />
                </div>
            </div>
            <div className="row" style={props.isMobile ? { marginTop: "5px" } : { marginTop: "10px" }}>
                <div className={props.isMobile ? "col-12" : "col-6"} style={props.isMobile ? {paddingBottom: "5px"} : {}}>
                    <MultiCheckBox
                        title={"구속 시작값"}
                        id="minBallSpeed"
                        name="minBallSpeed"
                        options={minBallSpeed}
                        value={props.criteria.minBallSpeed}
                        setValue={ballSpeedChangeHandler}
                        dataLang={"minBallSpeed"}
                        useLang={props.useLang}
                    />
                </div>
                <div className={props.isMobile ? "col-12" : "col-6"}>
                    <MultiCheckBox
                        title={"구속 종료값"}
                        id="maxBallSpeed"
                        name="maxBallSpeed"
                        options={maxBallSpeed}
                        value={props.criteria.maxBallSpeed}
                        setValue={ballSpeedChangeHandler}
                        dataLang={"maxBallSpeed"}
                        useLang={props.useLang}
                    />
                </div>
            </div>
			<div className="row" style={props.isMobile ? { marginTop: "5px" } : { marginTop: "10px" }}>
                <div className={props.isMobile ? "col-12" : "col-6"} style={props.isMobile ? {paddingBottom: "5px"} : {}}>
                    <MultiCheckBox
                        title={"타격결과"}
                        id="hitResults"
                        name="hitResults"
                        options={hitResults}
                        value={props.criteria.hitResults}
                        setValue={changeHandler}
                        dataLang={"playResult"}
                        useLang={props.useLang}
                    />
                </div>
                {/* <div className="col-6">
                    <MultiCheckBox
                        title={"타구랭크"}
                        id="battedBallRank"
                        name="battedBallRank"
                        options={battedBallRank}
                        value={props.criteria.battedBallRank}
                        setValue={changeHandler}
                        dataLang={"battedBallRank"}
                        useLang={props.useLang}
                    />
                </div> */}
            </div>
        </div>
    );
}
